<div class="form-control-group">
    <input
        #authoritySelectSearch
        nbInput
        type="text"
        [value]="authorityDisplayFn(selectedAuthority)"
        (input)="onAuthoritySelectSearchChange($event.target.value)"
        placeholder="Institūcija"
        [nbAutocomplete]="authoritySelect"
        fullWidth
    />

    <nb-autocomplete #authoritySelect (selectedChange)="onSelectedAuthorityChanged($event)" [handleDisplayFn]="authorityDisplayFn" fullWidth>
        <nb-option *ngFor="let authority of filteredAuthorities$ | async" [value]="authority">{{ authority.name }} ({{ authority.role }}) </nb-option>
    </nb-autocomplete>
</div>
